export const platformStats = [
  {
    name: "courses",
    value: 325,
    label: "<b>Courses</b> on our platform",
  },
  {
    name: "students",
    value: 8065,
    label: "<b>Students</b> for today",
  },
  {
    name: "score",
    value: 184,
    label: "<b>Average</b> score of our students",
  },
  {
    name: "certificates",
    value: 12678,
    label: "<b>Certificates</b> issued",
  },
];
